'use client';

import classNames from 'classnames';
import { HorizontalSelectOption } from './types';
import './styles.scss';

interface HorizontalSelectListProps {
  className?: string;
  onChange: (val: string) => void;
  onBlur?: () => void;
  options: HorizontalSelectOption[];
  value: string;
}

const HorizontalSelectList = ({
  className,
  options,
  onChange,
  value,
  onBlur,
}: HorizontalSelectListProps) => {
  return (
    <div
      className={classNames(
        'horizontal-select-list flex h-[76px] w-full overflow-hidden rounded-2xl border-[1px] border-gray-200 dark:border-gray-700',
        {
          'max-w-[238px]': options?.length === 1,
        },
        className
      )}>
      {options.map((option, idx) => {
        const isFirstItem = !idx;
        const isLasIttem = idx === options.length - 1;
        const isNotFirstNotLastItem = !isFirstItem && !isLasIttem;
        return (
          <div
            key={idx}
            onClick={() => {
              onChange(option.value);
              onBlur?.();
            }}
            tabIndex={0}
            className={classNames(
              'list-option m-1 flex flex-1 cursor-pointer flex-col justify-center gap-3 border-gray-200 px-3 pt-2 text-sm text-gray-600 transition duration-200 hover:bg-gray-100 hover:text-gray-600 focus:bg-gray-100 focus:text-gray-600 active:bg-gray-100 active:text-gray-600 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-300 dark:focus:bg-gray-800 dark:active:bg-gray-800',
              {
                '!text-primary dark:!bg-primary dark:!text-primary-content !bg-blue-100':
                  option.value === value,
                'rounded-s-xl rounded-e-md': isFirstItem,
                'rounded-s-md rounded-e-xl': isLasIttem,
                'rounded-md': isNotFirstNotLastItem,
              }
            )}>
            <div>{option.icon}</div>
            <div>{option.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalSelectList;
